"use strict";

var $ = require("jquery");
import { navCategoriesSliderToSlide } from './_navCategoriesToSlide.js';

function navCategoriesSliderToDefault() {

    if ($(window).width() >= 1200) {
        navCategoriesSliderToSlide(2);
    } else {
        navCategoriesSliderToSlide(0);
    }
}

$(document).ready(function () {

    $('.nav-categories-btn').on('click', function () {
        navCategoriesSliderToDefault();
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            navCategoriesSliderToDefault();
        }
    });

    window.addEventListener('resize', () => {
        navCategoriesSliderToDefault();
    });
});